import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('pilotMultiSelectPanelField');

    return {
        NO_PILOTS_FOUND: t('noPilotsFound'),
        SEARCH: t('search')
    };
};

export default useTranslation;
